// extracted by mini-css-extract-plugin
export default {"Userdetails":"UserProfileCard_Userdetails__IxCcL","closeIcon":"UserProfileCard_closeIcon__19O4l","reactBlockies":"UserProfileCard_reactBlockies__PHcr5"};